<template>
    <v-container fluid>
        <div class="carecall">
            <v-toolbar dense class="mb-3" v-if="sensors.length">
                <v-toolbar-title class="mr-2">
                    Pflegerufe letzte

                </v-toolbar-title>
                <v-btn-toggle v-model="timescale" mandatory>
                    <v-btn flat active value="12">
                        12h
                    </v-btn>
                    <v-btn flat value="24">
                        24h
                    </v-btn>
                </v-btn-toggle>
            </v-toolbar>
            <div :key="sensor.device" class="mb-4" v-for="sensor in sensors">
                <v-layout row align-center class="sensor__label">
                    <h2> {{sensor.environment.label}}</h2>
                    <v-spacer></v-spacer>
                    <v-tooltip left>
                        <v-icon slot="activator" class="sensor__connection"
                                :class="{'sensor__connection--active': sensor.hasConnection}">
                            <template v-if="sensor.hasConnection">wifi</template>
                            <template v-else>wifi_off</template>
                        </v-icon>
                        <span>Letzte Verbindung: {{new Date(sensor.ts).toLocaleString('de-DE')}}</span>
                    </v-tooltip>
                </v-layout>
                <v-layout row wrap justify-space-between align-center class="sensor__alarms mb-3" v-if="sensor.values">
                    <v-flex>
                        <h4>{{sensor.alarmSeries[timescale].length}} <span
                                v-if="sensor.alarmSeries[timescale].length=== 1">Pflegeruf</span><span
                                v-else>Pflegerufe</span></h4>
                    </v-flex>
                    <v-flex>
                        <care-call-timeline :height="30" :timescale="parseInt(timescale)"
                                            :alarms="sensor.alarmSeries[timescale]"></care-call-timeline>
                    </v-flex>
                </v-layout>
                <h4 class="sensor__novalues" v-else>Keine Sensorwerte vorhanden. Bitte Konfiguration überprüfen.</h4>
            </div>
        </div>
    </v-container>
</template>

<script>
import CareCallTimeline from '../components/CareCallTimeline'
import { createNamespacedHelpers } from 'vuex'

const {mapActions, mapState} = createNamespacedHelpers('sensor')

export default {
  name: 'AlarmSummary',
  components: {CareCallTimeline},
  data () {
    return {
      'timescale': '12'
    }
  },
  computed: mapState({
    sensors: state => state.sensors,
  }),
  methods: {
    ...mapActions([
      'getSensors',
      'getSensorValues'
    ])
  },
  async created () {
    await this.getSensors()
    this.$store.commit('core/setViewLoading', false)
    this.updater = setInterval(() => {
      this.getSensorValues()
    }, 9000)
  },
  destroyed () {
    clearInterval(this.updater)
  }
}
</script>

<style>
    .sensor__alarms {
        border-bottom: 6px solid #aca89d;
        padding-bottom: 12px;
        margin: 0 24px;
    }

    .carecall {
        background-color: #FEFEFE;
        overflow: hidden;
        border-radius: 4px;
    }
</style>
